import { createTheme, ThemeProvider } from '@mui/material/styles';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { SnackbarProvider } from 'notistack';
import * as React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from "react-router-dom";
import { ApiContext } from './components/ApiProvider';
import Layout from './components/Layout';
import SignIn from './pages/SignIn';

import { makeStyles } from '@mui/styles';
import './App.css';
import themeOptions from './theme';

const useStyles = makeStyles(() => ({
  snackbar: {
    zIndex: '1000000 !important',
  },
}));

const AuthenticatedApp = () => {
  const theme = createTheme(themeOptions);
  const classes = useStyles();

  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <SnackbarProvider dense={true} anchorOrigin={{ vertical: 'top', horizontal: 'right' }} autoHideDuration={2500} classes={{ containerRoot: classes.snackbar }}>
          <div className="App">
            <BrowserRouter>
              <Routes>
                <Route path="/*" element={<Layout />} />
              </Routes>
            </BrowserRouter>
          </div>
        </SnackbarProvider>
      </LocalizationProvider>
    </ThemeProvider>
  );
};

const UnauthenticatedApp = () => {
  const theme = createTheme(themeOptions);
  return (
    <ThemeProvider theme={theme}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <div className="App">
          <BrowserRouter>
            <Routes>
              <Route index element={<SignIn />} />
              {/* A step link opened signed out (e.g. reloaded after the token expired) goes to sign-in */}
              <Route path="*" element={<Navigate to="/" replace />} />
            </Routes>
          </BrowserRouter>
        </div>
      </LocalizationProvider>
    </ThemeProvider>
  );
}

function App() {
  const { isAuthenticated } = React.useContext(ApiContext);
  return isAuthenticated ? <AuthenticatedApp /> : <UnauthenticatedApp />;
}

export default App;
